var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import Navbar from "reactstrap/lib/Navbar";
import Nav from "reactstrap/lib/Nav";
import { withRouter } from "react-router";
import NavItem from "reactstrap/lib/NavItem";
import NavLink from "reactstrap/lib/NavLink";
import NavbarToggler from "reactstrap/lib/NavbarToggler";
import Collapse from "reactstrap/lib/Collapse";
var SideBar = /** @class */ (function (_super) {
    __extends(SideBar, _super);
    function SideBar(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isOpen: false
        };
        _this.toggle = _this.toggle.bind(_this);
        return _this;
    }
    SideBar.prototype.toggle = function () {
        this.setState({
            isOpen: !this.state.isOpen
        });
    };
    SideBar.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "sidebar " + (this.state.isOpen ? 'mobile-open' : '') + ' ' + (this.props.className || '') },
            React.createElement(Navbar, { color: "bpm", expand: "bpm-brk-4" },
                React.createElement(NavbarToggler, { onClick: this.toggle },
                    React.createElement("div", null),
                    React.createElement("div", null),
                    React.createElement("div", null)),
                React.createElement(Collapse, { isOpen: this.state.isOpen, navbar: true, style: { maxWidth: '100%' } },
                    React.createElement(Nav, { className: "ml-auto" }, this.props.pages.map(function (item, index) {
                        var active = _this.props.subPage == item.path && !Boolean(item.preventSelection);
                        return React.createElement(NavItem, { active: active, key: index, className: "header-nav-item nav-" + item.path },
                            React.createElement(NavLink, { href: "javascript:void(0)", onClick: function () {
                                    if (item.preventSelection) {
                                        return;
                                    }
                                    var url = '/' + _this.props.match.params.page;
                                    if (item.path) {
                                        url += '/' + encodeURIComponent(item.path);
                                    }
                                    _this.props.history.push(url, _this.props.location.state);
                                    if (_this.state.isOpen) {
                                        _this.toggle();
                                    }
                                }, style: item.noHeightRestriction ? { height: 'unset' } : {} }, item.render ? item.render(item) : React.createElement("span", { className: "align-middle" },
                                item.icon && React.createElement("span", { className: 'icon-container' },
                                    React.createElement("img", { src: item.icon, height: item.icon_height })),
                                React.createElement("span", { className: "sidebar-text" }, item.title))));
                    })))),
            this.props.renderBottomContent && this.props.renderBottomContent()));
    };
    return SideBar;
}(React.Component));
export default withRouter(SideBar);
//# sourceMappingURL=Sidebar.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/layout/Sidebar.js
// module id = 482
// module chunks = 0